import { render } from "./tools.vue?vue&type=template&id=fa24f904"
import script from "./tools.vue?vue&type=script&lang=js"
export * from "./tools.vue?vue&type=script&lang=js"

import "./tools.vue?vue&type=style&index=0&id=fa24f904&lang=css"

import exportComponent from "E:\\istero\\code\\istero-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__